import {generatePath, useNavigate} from 'react-router';

import {TItemId} from 'src/constants';

const useRedirectToItem = () => {
  const navigate = useNavigate();

  return (path: string, result?: TAnyObject | TItemId | null, replace = false, params = {}) => {
    const id = typeof result === 'object' ? result?.id : result;

    return navigate(generatePath(path, {id: String(id), ...params}), {
      replace,
    });
  };
};

export default useRedirectToItem;
